import { Box } from '@mui/material';
import React from 'react';
import noResultFound from '../media/Images/NoResultsFound.png';

const NoResultsFound = () => {
  return (
    <Box display='flex' justifyContent='center'>
      <img style={{maxWidth:'300px',mixBlendMode:'multiply'}} src={noResultFound} alt="No Results Found" />
    </Box>
  );
};

export default NoResultsFound;
